/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

import { GatsbySeo } from 'gatsby-plugin-next-seo';
import {img1} from './want_sub.png'
import {img2} from './pop2.webp'


// import Header from "./header"
import "./layout.css"


// place inside footrex

// <div  >{ data.allMdx.nodes.map(({ excerpt, frontmatter }) => 
//   <>
   
//    <Link to={frontmatter.path} style={{
//   color: 'grey',
// }}>{frontmatter.title}</Link>




//   <br />
//   </>
// )}
// </div>


const Layout = ({ children }) => {


  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
       allMdx{
            nodes {
                id
                excerpt(pruneLength: 250)
                frontmatter {
                    title
                    date
                    path
                }
            }
        }
    }
  `)




  return (
    <>
 
      <div
        style={{
          // margin: `1rem auto`,
          // maxWidth: 960,
          // padding: `0 1.0875rem 1.45rem`,
        }}
      >



    <GatsbySeo
      title='Automatically add subtitles in 30+ languages | Free | No Watermark'
      description='Increase user engagement on videos by adding text, heading, auto-generated subtitles, progress bar and more in minutes!'
      canonical='https://www.turtleclip.com/'
      openGraph={{
        url: 'https://www.turtleclip.com/',
        title: 'Automatically add subtitles in 30+ languages | Free | No Watermark',
        description: 'Increase user engagement on videos by adding text, heading, auto-generated subtitles, progress bar and more in minutes!',
        images: [
          {
            url: 'https://www.turtleclip.com/pop2.webp',
            width: 800,
            height: 600,
            alt: 'automatically add subtitles, text & transcription in minutes',
          },
          {
            url: 'https://www.turtleclip.com/og-image-02.jpg',
            width: 900,
            height: 800,
            alt: 'Og Image Alt Second',
          },
          { url: 'https://www.turtleclip.com/full.webp' },
          // { url: 'https://www.turtleclip.com/og-image-04.jpg' },
        ],
        site_name: 'TurtleClip',
      }}
      twitter={{
        handle: '@handle',
        site: '@site',
        cardType: 'summary_large_image',
      }}
    />




        <main>{children}</main>

        
        <footer className='foot'>
          © {new Date().getFullYear()}
          {` `}
        <Link to="/">TurtleClip</Link>
        </footer>


        <div className='footerx'>

      <Link to="/add-captions-to-insta-video">add captions to video</Link>
      <br />
      <Link to="/translate-zoom-video">translate video</Link>
      <br />
      <Link to="/how-to-subtitle-in-arabic">Subtitle in Arabic</Link>
      <br />
      <Link to="/easy-transcribe-spanish-audio">Subtitle in Spanish</Link>
      <br />


        </div>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
